export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8466.d60e0bc9.jpg";